import { Component, OnInit, ViewChild } from '@angular/core';
import { TestimonailsService } from 'src/app/services/testimonails.service';
import { Testimonial } from 'src/app/models/testimonial';
import { ActivatedRoute } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent implements OnInit {
  public testimonial:Testimonial;
  public loaded:boolean=false;
  public testimonialId;
  public Editor = ClassicEditor;
  @ViewChild("testimonialEditor", {static: false}) testimonialEditor:any;

  constructor(
    private _testimonial: TestimonailsService,
    private _route: ActivatedRoute,
    private _notify: NotificationService
  ) {
    this.testimonialId=this._route.snapshot.paramMap.get("id");
  }

  getTestimonial(id:number){
    this._testimonial.getTestimonial(id).subscribe(
      res=>{
        this.testimonial=new Testimonial(res);
        this.loaded=true;
      }
    );
  }

  saveChanges(){
    if(this.testimonial.title=='') return this._notify.showMessage('Title can not be blank.', 'OK');
    if(!this.testimonial.testimonial && this.testimonial.published) return this._notify.showMessage('You can not publish an empty testimonial.', 'OK');
    this._testimonial.updateTestimonial(this.testimonial).subscribe(
      res=>{
        this.testimonial=new Testimonial(res);
      }
    );
  }

  ngOnInit() {
    this.getTestimonial(this.testimonialId);
  }

}
